import { PreTransaction } from "@/app/services/authorizationService/getAuthorization";
import { PartnerType } from "@/app/utils/partners.enum";
import { onlyFirstName } from "@/app/utils/onlyFirstName";
import Status from "@/view/components/Status";
import { PartnerImage } from "@/view/components/PartnerImage";
import { Button } from "@/view/components/ui/button";
import { Spinner } from "@/view/components/ui/spinner";
import { authorizationStatusMap } from "@/app/utils/authorization";
import { format, isValid } from "date-fns";
import { ProductCatalogItem } from "@/app/services/configService/getProductsCatalog";

const formatDate = (value?: string | null) => {
  if (!value) return "-";
  const date = new Date(value);
  return isValid(date) ? format(date, "dd/MM/yyyy, HH:mm") : "-";
};

interface Props {
  items: PreTransaction[];
  onClick: (item: PreTransaction) => void;
  onLoadMore: () => void;
  isLoadingMore?: boolean;
  hasMore?: boolean;
  products?: ProductCatalogItem[];
}

export function MobileAuthorizationList({
  items,
  onClick,
  onLoadMore,
  isLoadingMore,
  hasMore,
  products,
}: Props) {
  return (
    <div className="flex flex-col gap-2">
      {items.map((item) => (
        <button
          key={item._id}
          onClick={() => onClick(item)}
          className="flex items-center justify-between rounded-xl border p-4 text-left"
        >
          <div className="flex items-center gap-3">
            <PartnerImage type={item.type || PartnerType.C6} products={products} />
            <div>
              <p className="font-medium">
                {onlyFirstName(item.customerId?.name || "Sem cliente")}
              </p>
              <p className="text-sm text-gray-500">{formatDate(item.createdAt)}</p>
            </div>
          </div>
          <div className="shrink-0">
            <Status status={authorizationStatusMap[item.status]} />
          </div>
        </button>
      ))}

      {hasMore && (
        <div className="flex py-4">
          <Button
            onClick={onLoadMore}
            disabled={isLoadingMore}
            variant="outline"
            className="w-[160px] rounded-full text-primary"
          >
            {isLoadingMore ? <Spinner /> : "Carregar mais"}
          </Button>
        </div>
      )}
    </div>
  );
}
